import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import styles from "styles/public.module.css";

function AuthFormShell({
  title,
  subtitle,
  organization,
  currentStep = 0,
  steps = [],
  children,
  footer,
}) {
  const showSteps = steps.length > 1;

  return (
    <Paper elevation={0} className={styles["auth-card"]}>
      {showSteps ? (
        <div className={styles["auth-steps"]} aria-label="Form progress">
          {steps.map((label, index) => (
            <div
              key={label}
              className={[
                styles["auth-step"],
                index === currentStep ? styles["auth-step-active"] : "",
                index < currentStep ? styles["auth-step-done"] : "",
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <span className={styles["auth-step-dot"]}>{index + 1}</span>
              <span className={styles["auth-step-label"]}>{label}</span>
            </div>
          ))}
        </div>
      ) : null}

      <div className={styles["auth-header"]}>
        <div className={styles["auth-header-text"]}>
          <h2 className={styles["auth-title"]}>{title}</h2>
          {subtitle ? <p className={styles["auth-subtitle"]}>{subtitle}</p> : null}
        </div>
        {organization ? (
          <Chip
            label={organization}
            size="small"
            color="primary"
            variant="outlined"
            className={styles["auth-org-chip"]}
          />
        ) : null}
      </div>

      {children}

      {footer ? <div className={styles["auth-footer"]}>{footer}</div> : null}
    </Paper>
  );
}

export default AuthFormShell;
